import { Theme, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    minHeight: 500,
    "& .MuiDataGrid-columnHeaderWrapper": {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
    },
    "& .MuiDataGrid-columnHeaderWrapper .MuiIconButton-label svg": { color: "rgba(255,255,255,1)" },
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
    color: "#fff",
  },
  cardMain: {
    marginBottom: "0px",
    paddingTop: "2px",
    width: "calc(100%)",
    overflow: "auto",
  },
  pageHeading: {
    fontSize: theme.typography.pxToRem(20),
    // fontWeight: theme.typography.fontWeightRegular,
    color: "#000",
  },
  tabRow: {
    flexDirection: "row-reverse",
    paddingLeft: 0,
    // backgroundColor: "#e7e7e7",
  },
  tabIcon: {
    border: "solid #E67817 1px",
    borderRadius: "50%",
    "&.MuiSvgIcon-root": {
      fill: "#E67817",
    },
  },
  "&.MuiCard-root": {
    overflow: "scroll",
  },
  button: {
    minWidth: "10px",
    boxShadow: "0px 0px 2px #00000029",
    border: "0.5px solid #E6E6E6",
    margin: "10px 5px",
    zIndex: 1,
    float: "right",
  },
  hideDatesGrid: {
    display: "none",
  },
  checkButton: {
    color: "#ffffff",
    backgroundColor: "#72CA00",
    padding: "8px",
  },
  tabLabelCustom: {
    position: "absolute",
    bottom: "42%",
  },

  outer: {
    border: "0.5px solid #E6E6E6",
    borderRadius: "8px",
    boxShadow: "0px 0px 2px #00000029",
    padding: "15px",
  },
  heading: {
    fontSize: "14px",
    fontWeight: 700,
    marginTop: "15px",
    marginBottom: "15px",
  },
  headingAmount: {
    fontSize: "16px",
    fontWeight: 600,
    color: "#488CFB",
    marginTop: "6px",
  },
  unit: {
    marginBottom: "15px",
    padding: "8px 5px",
    fontWeight: 600,
  },
  headingText: {
    marginBottom: "15px",
    padding: "6px",
    fontWeight: 600,
    fontSize: "16px",
  },
  itemsList: {
    maxHeight: "350px",
    overflowY: "auto",
    paddingRight: "15px",
  },
  item: {
    padding: "10px 10px 0 10px",
    borderRadius: "4px",
    "&:hover": {
      backgroundColor: "#e7e7e7",
      cursor: "pointer",
    },
  },
  selectedItem: {
    backgroundColor: "#e7e7e7",
  },
  labelNumber: {
    fontSize: "14px",
    fontWeight: 700,
    textAlign: "right",
  },
  label: {
    width: "80%",
  },
  itemAmount: {
    fontSize: "11px",
    color: "#9E9E9E",
  },
  pieChartDiv: {
    display: "flex",
    justifyContent: "center",
    paddingLeft: "30px",
  },
  revenueTypesItem: {
    border: "0.5px solid #E6E6E6",
    borderRadius: "8px",
    boxShadow: "0px 0px 2px #00000029",
    padding: "15px 15px 0 15px",
    margin: "0 15px 15px",
    maxWidth: "90%",
  },
  barChartItemAmount: {
    fontWeight: 700,
    textAlign: "right",
  },
  barChartItem: {
    padding: "0 10px",
  },

  blueTable: {
    border: "1px solid #97b1de",
    borderCollapse: "collapse",
    marginBottom: "15px",
    fontSize: "14px",
    tableLayout: "fixed",
    width: "100%",
  },
  tableCells: {
    border: "1px solid #97b1de",
    padding: "10px",
  },
  bodytd: {
    color: "#000000",
    width: "auto",
    minWidth: "100px",
    textAlign: "center",
  },
  bodytdBT: {
    minWidth: "150px",
  },
  nthChild: {
    background: "#dae3f3",
  },
  tHead: {
    borderBottom: "2px solid #97b1de",
  },
  multiselectConfigFileCompression: {
    position: "relative",
    paddingLeft: "4px",
    "& .searchWrapper": {
      border: "none",
      maxHeight: "35px",
      overflow: "auto",
    },
    "& ::placeholder": {
      color: "#bcbcbc",
    },
  },

  level4Table: {
    maxHeight: "400px",
  },
  level4TableHead: {
    background: "#4472c4",
    color: "white",
    textAlign: "center",
  },
  level4SubHeadings: {
    fontWeight: "bold",
  },
  level4Cells: {
    padding: "0 10px",
  },
  evenRow: {
    background: "#cfd5ea",
  },
  oddRow: {
    background: "#e9ebf5",
  },
  level4TableOrangeHead: {
    color: "white",
    backgroundColor: "#008000",
    padding: "10px",
    fontSize: "14px",
    "& p": {
      marginTop: "5px",
      marginBottom: "5px",
    },
  },
  topDivHeadings: {
    fontWeight: "bold",
    fontSize: "16px",
  },
}));
